import { Route, Routes } from 'react-router-dom';

import ViewContactGroup from '../components/Contact_Groups/ViewContactGroup';
import ContactGroupList from '../components/Contact_Groups/ContactGroupList';
import EditContactGroup from '../components/Contact_Groups/EditContactGroup';


const ContactGroups = () => {
  return (
    <Routes>
      <Route path="/" element={<ContactGroupList />} />
      <Route path="/edit/:id" element={<EditContactGroup />} />
      <Route path="/edit" element={<EditContactGroup />} />
      <Route path="/view/:id" element={<ViewContactGroup />} />
    </Routes>
  )
}

export default ContactGroups;